import { render, staticRenderFns } from "./menuResource.vue?vue&type=template&id=8161d16e&scoped=true"
import script from "./menuResource.vue?vue&type=script&lang=js"
export * from "./menuResource.vue?vue&type=script&lang=js"
import style0 from "./menuResource.vue?vue&type=style&index=0&id=8161d16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8161d16e",
  null
  
)

export default component.exports